import React from 'react';
import { useTranslation } from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import Button from '@mui/material/Button';


const LanguageSwitcher = ({onUpdate}) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = React.useState(false);
    const navigate = useNavigate();
    const changeLanguage = (lng) => {
      setIsOpen(false);
      i18n.changeLanguage(lng);
      navigate(window.location.pathname+window.location.search,{replace: true,lang:lng});
    };
    return (
      <div className='language-switcher'>
        <button onClick={() => setIsOpen(!isOpen)} className='language-switcher__button' >
          <span className={`fi fi-${i18n.language.includes('en') ? 'gb': 'it'}`}></span>
        </button>
        {isOpen && (
          <div className='language-switcher__dropdown'>
            <Button onClick={() => changeLanguage('it')} className='language-switcher__item'>
              <span className='fi fi-it'></span> Italiano
            </Button>
            <Button onClick={() => changeLanguage('en')} className='language-switcher__item'>
              <span className='fi fi-gb'></span> English
            </Button>
          </div>
        )}
      </div>
    );
  };

  export default LanguageSwitcher;